import styled from 'styled-components';
import { Styling } from '../../../../constants/styling';

export const BlackoutContainer = styled.div`
  height: calc(100vh - ${Styling.HEADER_HEIGHT}px - var(--impersonation-banner-height, 0px));
  flex: 1;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  margin-top: 64px;
  position: absolute;
  left: 0;
  z-index: 1;

  & > .MuiDialog-root.MuiModal-root {
    top: 64px;
  }
`;

export const DialogContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  padding: 20px;
  padding-bottom: 15px;
  height: 115px;
  overflow: overlay;
`;
